import { defineStore } from "pinia";
import { ref } from "vue";

export const useTableFilter = defineStore("tableFilter", () => {
  const isFiltered = ref(false);

  const setFiltered = (value) => {
    isFiltered.value = value;
  };

  const resetFilter = () => {
    isFiltered.value = false;
  };

  return {
    isFiltered,
    setFiltered,
    resetFilter,
  };
});
